const messages = {
  pt: {
    translations: {
      pages: {
        agents: {
          title: "Assistentes",
          labels: {
            edit: "Editar",
            del: "Excluir",
            name: "Nome",
            model: "Modelo",
            visibility: "Visibilidade",
            createdAt: "Criado em",
            actions: "Ações",
            functions: "Funções",
            createFunction: "Criar função",
            notFoundFc: "Nenhum função encontrada.",
            error: {
              createAgent: "Ops! Erro ao criar novo assistente.",
              updateAgent: "Ops! Erro ao atualizar assistente.",
              deleteAgent: "Ops! Erro ao deletar assistente.",
              createFunction: "Ops! Erro ao criar função.",
              deleteFunction: "Ops! Erro ao deletar função.",
              updateFunction: "Ops! Erro ao atualizar função."
            },
            success: {
              createAgent: "Assistente criado com sucesso.",
              updateAgent: "Assistente atualizado com sucesso.",
              deleteAgent: "Assistente deletado com sucesso.",
              createFunction: "Função criada com sucesso.",
              deleteFunction: "Função deletada com sucesso.",
              updateFunction: "Função atualizada com sucesso.",
              confirmFunction: "Tem certeza que deseja excluir a função"
            }
          },
          modalFunctions: {
            title: "Criar Função Personalizada",
            type: "Tipo",
            name: "Nome",
            description: "Descrição",
            properties: "Propriedades",
            method: "Método",
            url: "URL",
            accept: "Aceitar",
            httpRequest: "Requisição Web",
            value: "Valor",
            key: "Chave",
            close: "Fechar",
            headers: "Cabeçalhos",
            required: "Obrigatório",
            openDescription: "Descrição em tela cheia",
            updateFunction: "Atualizar função",
            save: "Salvar",
            labels: {
              required: {
                name: "Nome é obrigatório.",
                description: "Descrição é obrigatória.",
                type: "Tipo é obrigatório.",
                method: "Método é obrigatório.",
                url: "Digite uma URL válida.",
                headers: "Cabeçalho é obrigatório.",
                properties: "Propriedades são obrigatórias."
              }
            },
            types: {
              string: "Texto",
              integer: "Inteiro",
              number: "Número",
              boolean: "Booleano",
              object: "Objeto",
              array: "Lista",
              audio: "Audio",
              video: "Video",
              image: "Imagem",
              document: "Arquivo"
            },
            select: {
              audio: "Selecione um audio",
              video: "Selecione um video",
              image: "Selecione uma imagem",
              document: "Selecione um arquivo"
            },
            attached: {
              audio: "Audio anexado",
              video: "Video anexado",
              image: "Imagem anexado",
              document: "Arquivo anexado"
            }
          },
          modal: {
            close: "Fechar",
            openInstructions: "Instruções em tela cheia",
            title: "Criar Novo Assistente",
            subtitle: "Configure as propriedades do seu assistente de IA",
            editTitle: "Editar Assistente",
            editSubtitle: "Atualize as propriedades do assistente",
            name: "Nome do Assistente",
            description: "Descrição (opcional)",
            instructions: "Instruções",
            instructionsHelper:
              "Descreva como o assistente deve se comportar e responder",
            model: "Modelo",
            tools: "Ferramentas",
            toolsHelper: "Selecione as ferramentas que o assistente pode usar",
            responseFormat: "Formato de Resposta",
            temperature: "Temperatura",
            topP: "Top P",
            metadata: "Metadados",
            category: "Categoria",
            version: "Versão",
            btn: "Criar Assistente",
            btnEdit: "Atualizar Assistente",
            confirmAgent: "Tem certeza que deseja excluir o assistente",
            codeInterpreter: "Interpretador de código",
            webSearch: "Pesquisa na web",
            tone: "Tom da conversa",
            style: "Estilo de resposta",
            maxTokens: "Limite de Tokens",
            visibility: "Visibilidade",
            private: "Privado",
            public: "Público",
            tones: {
              toneFormal: "Formal",
              toneInformal: "Informal",
              toneFriendly: "Amigável",
              toneProfessional: "Profissional",
              toneMotivational: "Motivacional",
              toneEmpathetic: "Empático",
              toneHumorous: "Divertido"
            },
            styles: {
              styleBrief: "Curto",
              styleDetailed: "Detalhado",
              styleTechnical: "Técnico",
              styleCreative: "Criativo",
              styleSummary: "Resumo",
              styleList: "Lista",
              styleConversational: "Conversacional"
            }
          },
          techProvider: {
            title: "Validacao do WhatsApp",
            subtitle: "Gerencie templates, sincronize o webhook e acompanhe envio e recebimento do numero configurado.",
            alerts: {
              configure: "Configure WHATSAPP_TEST_PHONE_NUMBER_ID, WHATSAPP_TEST_TOKEN e WHATSAPP_TEST_WABA no backend para liberar esta tela.",
              validationError: "Nao foi possivel validar o phone_number_id configurado:"
            },
            common: {
              configured: "Configurado",
              pending: "Pendente",
              refresh: "Atualizar",
              refreshing: "Atualizando...",
              sending: "Enviando...",
              loading: "carregando...",
              notAvailable: "N/D",
              status: "Status",
              noStatus: "sem status",
              contact: "Contato",
              template: "Template",
              you: "Voce"
            },
            categories: {
              utility: "Utilitario",
              marketing: "Marketing",
              authentication: "Autenticacao"
            },
            stats: {
              phoneNumberId: "Phone Number ID",
              waba: "WABA",
              templates: "Templates",
              webhook: "Webhook",
              visibleNumber: "Numero visivel",
              waitingApproval: "{{count}} aguardando aprovacao"
            },
            webhook: {
              title: "Sincronizacao do webhook",
              description: "Use este passo antes dos testes de envio e recebimento para garantir que a WABA de teste esteja apontando para este backend.",
              sync: "Sincronizar webhook",
              syncing: "Sincronizando...",
              subscribedApps: "Apps inscritas agora: {{count}}",
              appWithoutName: "App sem nome"
            },
            templateCreate: {
              title: "1. Enviar template para aprovacao",
              description: "Monte um template simples, sem variaveis, para agilizar a revisao.",
              open: "Abrir criacao de template",
              name: "Nome do template",
              nameHelper: "Use letras minusculas, numeros e underline.",
              category: "Categoria",
              language: "Idioma",
              header: "Header (opcional)",
              body: "Body do template",
              footer: "Footer (opcional)",
              submit: "Enviar para aprovacao"
            },
            templateSend: {
              title: "2. Enviar template aprovado",
              description: "Use o nome de um template aprovado e o numero de destino para validar o envio.",
              open: "Abrir envio de template",
              to: "Destino (com DDI)",
              templateName: "Nome do template",
              language: "Idioma do template",
              bodyParameters: "Parametros do body (1 por linha, opcional)",
              submit: "Enviar template"
            },
            chat: {
              title: "3. Chat de teste em tempo real",
              description: "Abra o chat para acompanhar as mensagens e os status ao vivo via socket.",
              target: "Numero de destino (somente DDI + telefone)",
              targetHelper: "O backend normaliza automaticamente para o formato aceito pela Meta.",
              socketConnected: "Socket conectado",
              socketDisconnected: "Socket desconectado",
              talkingTo: "Conversando com {{target}}",
              defineTarget: "Defina o numero de destino para abrir a conversa filtrada.",
              open: "Abrir chat",
              refreshHistory: "Atualizar historico"
            },
            templates: {
              title: "Templates disponiveis",
              description: "Clique em usar para preencher automaticamente o formulario de envio.",
              use: "Usar este template",
              empty: "Nenhum template retornado para esta WABA.",
              noCategory: "Sem categoria",
              noLanguage: "Sem idioma",
              noVisibleBody: "Sem body visivel"
            },
            logs: {
              title: "Logs do WhatsApp",
              description: "Eventos enviados pelo backend e mensagens capturadas no webhook do numero de teste.",
              open: "Ver logs",
              clear: "Limpar",
              empty: "Nenhum evento ainda. Depois de enviar um template ou mensagem, os logs aparecem aqui e continuam atualizando."
            },
            chatModal: {
              title: "Chat do numero de teste",
              description: "Envio e recebimento em tempo real usando Socket.IO.",
              socketOnline: "Socket online",
              socketOffline: "Socket offline",
              destination: "Numero de destino",
              destinationHelper: "Use DDI + numero. O backend remove pontuacao, espacos e o sinal +.",
              noVisibleText: "Mensagem sem texto visivel",
              empty: "Nenhuma mensagem ainda para este destino. Envie uma mensagem e responda pelo WhatsApp para validar o fluxo.",
              message: "Mensagem",
              send: "Enviar mensagem",
              reload: "Recarregar eventos"
            },
            feedback: {
              success: {
                syncWebhook: "Webhook do numero de teste sincronizado.",
                templateCreated: "Template enviado para aprovacao.",
                templateSent: "Template enviado para o numero informado.",
                messageSent: "Mensagem enviada.",
                logsCleared: "Historico limpo."
              },
              errors: {
                loadConfig: "Erro ao carregar configuracao do numero de teste.",
                loadTemplates: "Erro ao listar templates.",
                loadApps: "Erro ao listar apps inscritas.",
                syncWebhook: "Erro ao sincronizar webhook.",
                createTemplate: "Erro ao enviar template para aprovacao.",
                sendTemplate: "Erro ao enviar template.",
                sendMessage: "Erro ao enviar mensagem.",
                clearLogs: "Erro ao limpar historico."
              }
            }
          }
        },
        whatsapp: {
          title: "Whatsapp",
          techProvider: {
            title: "Validacao do WhatsApp",
            subtitle: "Gerencie templates, sincronize o webhook e acompanhe envio e recebimento do numero configurado.",
            alerts: {
              configure: "Configure WHATSAPP_TEST_PHONE_NUMBER_ID, WHATSAPP_TEST_TOKEN e WHATSAPP_TEST_WABA no backend para liberar esta tela.",
              validationError: "Nao foi possivel validar o phone_number_id configurado:"
            },
            common: {
              configured: "Configurado",
              pending: "Pendente",
              refresh: "Atualizar",
              refreshing: "Atualizando...",
              sending: "Enviando...",
              loading: "carregando...",
              notAvailable: "N/D",
              status: "Status",
              noStatus: "sem status",
              contact: "Contato",
              template: "Template",
              you: "Voce"
            },
            categories: {
              utility: "Utilitario",
              marketing: "Marketing",
              authentication: "Autenticacao"
            },
            stats: {
              phoneNumberId: "Phone Number ID",
              waba: "WABA",
              templates: "Templates",
              webhook: "Webhook",
              visibleNumber: "Numero visivel",
              waitingApproval: "{{count}} aguardando aprovacao"
            },
            webhook: {
              title: "Sincronizacao do webhook",
              description: "Use este passo antes dos testes de envio e recebimento para garantir que a WABA de teste esteja apontando para este backend.",
              sync: "Sincronizar webhook",
              syncing: "Sincronizando...",
              subscribedApps: "Apps inscritas agora: {{count}}",
              appWithoutName: "App sem nome"
            },
            templateCreate: {
              title: "1. Enviar template para aprovacao",
              description: "Monte um template simples, sem variaveis, para agilizar a revisao.",
              name: "Nome do template",
              nameHelper: "Use letras minusculas, numeros e underline.",
              category: "Categoria",
              language: "Idioma",
              header: "Header (opcional)",
              body: "Body do template",
              footer: "Footer (opcional)",
              submit: "Enviar para aprovacao"
            },
            templateSend: {
              title: "2. Enviar template aprovado",
              description: "Use o nome de um template aprovado e o numero de destino para validar o envio.",
              to: "Destino (com DDI)",
              templateName: "Nome do template",
              language: "Idioma do template",
              bodyParameters: "Parametros do body (1 por linha, opcional)",
              submit: "Enviar template"
            },
            chat: {
              title: "3. Chat de teste em tempo real",
              description: "Abra o chat para acompanhar as mensagens e os status ao vivo via socket.",
              target: "Numero de destino (somente DDI + telefone)",
              targetHelper: "O backend normaliza automaticamente para o formato aceito pela Meta.",
              socketConnected: "Socket conectado",
              socketDisconnected: "Socket desconectado",
              talkingTo: "Conversando com {{target}}",
              defineTarget: "Defina o numero de destino para abrir a conversa filtrada.",
              open: "Abrir chat",
              refreshHistory: "Atualizar historico"
            },
            templates: {
              title: "Templates disponiveis",
              description: "Clique em usar para preencher automaticamente o formulario de envio.",
              use: "Usar este template",
              empty: "Nenhum template retornado para esta WABA.",
              noCategory: "Sem categoria",
              noLanguage: "Sem idioma",
              noVisibleBody: "Sem body visivel"
            },
            logs: {
              title: "Logs do WhatsApp",
              description: "Eventos enviados pelo backend e mensagens capturadas no webhook do numero de teste.",
              open: "Ver logs",
              clear: "Limpar",
              empty: "Nenhum evento ainda. Depois de enviar um template ou mensagem, os logs aparecem aqui e continuam atualizando."
            },
            chatModal: {
              title: "Chat do numero de teste",
              description: "Envio e recebimento em tempo real usando Socket.IO.",
              socketOnline: "Socket online",
              socketOffline: "Socket offline",
              destination: "Numero de destino",
              destinationHelper: "Use DDI + numero. O backend remove pontuacao, espacos e o sinal +.",
              noVisibleText: "Mensagem sem texto visivel",
              empty: "Nenhuma mensagem ainda para este destino. Envie uma mensagem e responda pelo WhatsApp para validar o fluxo.",
              message: "Mensagem",
              send: "Enviar mensagem",
              reload: "Recarregar eventos"
            },
            feedback: {
              success: {
                syncWebhook: "Webhook do numero de teste sincronizado.",
                templateCreated: "Template enviado para aprovacao.",
                templateSent: "Template enviado para o numero informado.",
                messageSent: "Mensagem enviada.",
                logsCleared: "Historico limpo."
              },
              errors: {
                loadConfig: "Erro ao carregar configuracao do numero de teste.",
                loadTemplates: "Erro ao listar templates.",
                loadApps: "Erro ao listar apps inscritas.",
                syncWebhook: "Erro ao sincronizar webhook.",
                createTemplate: "Erro ao enviar template para aprovacao.",
                sendTemplate: "Erro ao enviar template.",
                sendMessage: "Erro ao enviar mensagem.",
                clearLogs: "Erro ao limpar historico."
              }
            }
          },
          inbox: {
            title: "Conversas",
            labels: {
              noConversations: "Nenhuma conversa",
              noConversationsFound: "Nenhuma conversa encontrada",
              tryDifferentSearch: "Tente buscar com outros termos",
              startNewConversation: "Suas conversas aparecerão aqui",
              writeAddress:
                "Digite um endereço ou coordenadas (latitude, longitude)",
              sendContact: "Enviar contato",
              newMessageReceive: "Nova mensagem disponível",
              hideContent: "Ocultar legenda",
              showContent: "Mostrar legenda",
              renameContact: "Renomear contato",
              cancel: "Cancelar",
              enableAgent: "Ativar bot",
              conversations: "Conversas",
              disconnect: "Desconectar",
              edit: "Editar",
              loadConversations: "Carregando conversas",
              searchContact: "Pesquisar contato",
              menu: "Menu",
              moreOptions: "Mais opções",
              all: "Tudo",
              sendNewMessage: "Enviar nova mensagem",
              favorites: "Favoritas",
              search: "Pesquisar conversa",
              find: "Encontrar",
              dataContact: "Dados do contato",
              addFavorites: "Adicionar aos favoritos",
              removeFavorites: "Remover dos favoritos",
              closeChat: "Fechar conversa",
              findItem: "Pesquisar mensagens",
              message: "Recado",
              turnOff: "Apagar",
              copy: "Copiar",
              options: "Opções",
              download: "Baixar",
              messageNotFound: "Nenhuma mensagem encontrada.",
              attach: "Anexar",
              send: "Enviar",
              record: "Gravar",
              writeMessage: "Digite uma mensagem",
              deleteRecord: "Deletar",
              pause: "Pausar",
              play: "Tocar",
              files: "Arquivos",
              audio: "Audio",
              camera: "Camera",
              contact: "Contato",
              disableAgent: "Desativar Bot",
              writePhone: "Digite o número",
              phone: "Telefone",
              sending: "Enviando",
              notFoundChat:
                "Selecione uma conversa para começar a enviar mensagens.",
              confirmLocation: "Confirme sua localização",
              addCaption: "Adicione uma legenda",
              save: "Salvar",
              name: "Nome",
              attachments: {
                document: "Documento",
                video: "Video",
                location: "Localização",
                contact: "Contato",
                photos: "Fotos",
                photo: "Foto",
                audio: "Audio"
              },
              success: {
                sendLocation: "Localização enviada com sucesso.",
                sendContact: "Contato enviado com sucesso.",
                sendMessage: "Mensagem enviada com sucesso",
                copy: "Texto copiado com sucesso",
                enableBot: "Bot ativado com sucesso.",
                disableBot: "Bot desativado com sucesso.",
                renameContact: "Contato renomeado com sucesso."
              },
              error: {
                sendMessage: "Ops! Erro ao enviar mensagem.",
                sendDocument: "Ops! Erro ao enviar arquivo",
                sendContact: "Ops! Erro ao enviar contato",
                sendLocation: "Ops! Erro ao enviar localização",
                typeNotAllowed: "Tipo de arquivo não permitido.",
                bot: "Ops! Erro ao ativar/desativar bot.",
                authorizeLocation: "Autorize o uso da sua localização.",
                audio: "Houve um erro ao processar seu áudio.",
                renameContact: "Ops! Erro ao renomear contato.",
                getLocation: "Ops! Erro ao obter localização."
              },
              required: {
                message: "Mensagem é obrigatória.",
                number: "Número do contato é obrigatório.",
                imageUrl: "Selecione uma imagem válida.",
                audioUrl: "Houve um erro ao processar seu áudio.",
                documentUrl: "Selecione um documento válido.",
                videoUrl: "Houve um erro ao processar seu video.",
                contactPhone: "Selecione um contato válido.",
                nameLocation: "Nome do local é obrigatório.",
                addressLocation: "Endereço do local é obrigatório.",
                lat: "Latitude é obrigatória.",
                long: "Longitude é obrigatória.",
                name: "Nome do contato é obrigatório."
              }
            }
          },
          connections: {
            title: "Conexões",
            labels: {
              modal: {
                connectWhats: "Conectar WhatsApp",
                scannerText:
                  "Escaneie o QR code abaixo com o aplicativo WhatsApp para conectar",
                generateQr: "Gerando QR Code..."
              },
              assistant: "Assistente",
              errorWhats: "Falha",
              open: "Conectado",
              connect: "Conectar",
              online: "Online",
              offline: "Offline",
              pending: "Pendente",
              connecting: "Conectando",
              openChat: "Abrir Chat",
              closeConnection: "Encerrar Conexão",
              reconnect: "Reconectar",
              newConnection: "Nova conexão",
              edit: "Editar",
              delete: "Deletar",
              notFound: "Nenhuma conexão encontrada.",
              create: "Nova conexão",
              update: "Atualizar conexão",
              name: "Nome",
              add: "Adicionar",
              save: "Salvar",
              close: "Encerrada",
              required: {
                name: "Nome é obrigatório.",
                userId: "ID do usuário é obrigatório"
              },
              error: {
                create: "Ops! Erro ao criar nova conexão.",
                update: "Ops! Erro ao atualizar conexão.",
                delete: "Ops! Erro ao deletar conexão.",
                connected: "Uma conexão foi encerrada.",
                reconnect: "Ops! Erro ao reconectar conexão."
              },
              success: {
                create: "Conexão criada com sucesso.",
                update: "Conexão atualizada com sucesso.",
                delete: "Conexão deletada com sucesso.",
                connected: "Conexão estabelecida com sucesso.",
                reconnect: "Aguarde, estamos processando sua reconexão."
              }
            }
          }
        },
        finishRegister: {
          title: "Finalização de cadastro",
          labels: {
            finishing: "Finalizando...",
            finish: "Finalizar cadastro",
            titleComplete:
              "Complete seu cadastro agora e desbloqueie uma variedade de benefícios incríveis só para você!",
            subtitleComplete:
              "Aproveite nossos planos, eles estarão disponíveis por tempo limitado! Escolha o plano que mais se adapta às suas metas e conquiste melhores resultados!",
            selectType: "Selecione o tipo de conta:",
            password: "Senha",
            repeatPassword: "Repita a senha",
            state: "Estado",
            city: "Cidade",
            phone: "(DDD) + Telefone",
            address: "Endereço",
            addressComplement: "Endereço Complementar",
            document: "Documento de Identificação",
            plansTitle:
              "Potencialize suas vendas com esses pacotes exclusivos!",
            plansSubtitle:
              "Aproveite nossos planos, eles estarão disponíveis por tempo limitado! Escolha o plano que mais se adapta às suas metas e conquiste melhores resultados!",
            forMonth: "mês",
            success: {
              register: "Cadastro completado com sucesso."
            },
            error: {
              register: "Ops! erro ao finalizar seu cadastro."
            },
            benefits: {
              maxListings: "Até {{count}} anúncios imobiliários",
              maxImagesPerListing: "Até {{count}} imagens por anúncio",
              marketplace: "Marketplace de produtos e serviços",
              crmContacts: "Gestão de contatos (CRM)",
              crmNegotiations: "Gestão de Negociações (CRM)",
              exclusiveListings:
                "Anúncios imobiliários sem imóveis de terceiros",
              watermark: "Sua marca d'água nas imagens",
              whatsappOnProfile: "Seu Whatsapp no perfil e anúncio",
              publicProfile: "Perfil público com seus imóveis e redes sociais",
              coursesArea: "Área de cursos",
              propertySharingNetwork: "Rede de compartilhamento de imóveis",
              personalizedSupport: "Suporte personalizado (Helpdesk)",
              unlimitedAds: "Anúncios imobiliários ilimitados",
              unlimitedPhotos: "Imagens por anuncio ilimitadas"
            }
          }
        },
        login: {
          title: "Login",
          subtitle:
            "Bem-vindo! Por favor, insira suas credenciais para acessar sua conta.",
          labels: {
            button: "Acessar",
            register: "Ainda não possui conta?",
            forgot: "Esqueceu a senha?",
            error: {
              sign: "Ops! Falha no login. Verifique suas credenciais e tente novamente.",
              finish: "Conclua seu registro.",
              signGoogle: "Erro ao logar com google.",
              notExists: "Acesso Negado: Email ou senha inválidos.",
              notRegister:
                "Você não está registrado no sistema. Por favor, registre-se!"
            },
            success: {
              sign: "Login efetuado com sucesso!"
            }
          }
        },
        register: {
          title: "Crie sua conta no Zapps",
          subtitle: "Cadastre-se para ter acesso a recursos exclusivos",
          labels: {
            button: "Cadastrar-se",
            sign: "Já possui conta? faça login",
            error: {
              signGoogle: "Erro ao logar com google.",
              registerGoogle: "Erro ao se cadastrar com google.",
              register: "Erro ao criar conta no Zapps.",
              exists: "Conta já existe, faça login."
            },
            success: {
              register:
                "Quase lá! Complete seus dados para finalizar sua conta.!"
            }
          }
        },
        forgot: {
          title: "Recuperação de Senha",
          subtitle: "Redefina sua senha e recupere o acesso à sua conta.",
          labels: {
            recovery: "Recuperar",
            sign: "Fazer Login",
            sending: "Enviando email...",
            success: {
              send: "Email de recuperação enviado."
            },
            error: {
              send: "Ops! Erro ao enviar link de recuperação."
            }
          }
        },
        plans: {
          title: "Potencialize suas vendas com esses pacotes exclusivos!",
          subtitle:
            "Aproveite nossos planos, eles estarão disponíveis por tempo limitado! Escolha o plano que mais se adapta às suas metas e conquiste melhores resultados!",
          check: "Confirmar Plano",
          checking: "Confirmando...",
          labels: {
            error: {
              createSession:
                "Ops! Erro ao confirmar plano. Confira seus dados cadastrados."
            }
          }
        },
        popupChange: {
          title: "Seu plano está cancelado",
          subtitle: "Escolha um plano para continuar com acesso ao sistema."
        },
        users: {
          title: "Usuários",
          search: "Pesquisar",
          firstname: "Nome",
          lastname: "Sobrenome",
          email: "E-mail",
          phone: "Telefone",
          country: "País",
          state: "Estado",
          city: "Cidade",
          companyName: "Razão Social",
          license: "Licença",
          name: "Nome Completo",
          password: "Senha",
          userType: "Tipo de acesso",
          edit: "Salvar",
          administrator: "Administrador",
          broker: "CORRETOR",
          realEstate: "IMOBILIÁRIA",
          constructionCompany: "CONSTRUTORA",
          btnModal: "Novo usuário",
          btnEdit: "Editar",
          btnView: "Detalhes",
          btnDownload: "Baixar",
          btnRemove: "Excluir",
          accountType: "Tipo de conta",
          document: "Documento",
          modal: {
            title: "Registrar um novo usuário",
            btn: "Adicionar"
          },
          alerts: {
            editUser: "Usuário editado com sucesso.",
            incomplete: "Preencha os campos obrigatórios",
            create: "Usuário criado com sucesso.",
            deleteConfirm: "Você realmente deseja excluir este usuário?",
            deleted: "Usuário excluído com sucesso.",
            error: "Tente novamente",
            errorDel: "Erro ao deletar usuário.",
            errorCreate: "Erro ao criar usuário.",
            errorEdit: "Erro ao editar usuário"
          },
          labels: {
            firstname: "Nome é obrigatório.",
            lastname: "Sobrenome é obrigatório.",
            password: "Senha requer mínimo de 6 caracteres.",
            name: "Nome Completo é obrigatório.",
            email: "Email informado não é válido.",
            phone: "Telefone é obrigatório.",
            ddi: "DDI é obrigatório.",
            creci: "Licença é obrigatório.",
            country: "País é obrigatório.",
            state: "Estado é obrigatório.",
            city: "Cidade é obrigatório.",
            userType: "Tipo de usuário é obrigatório.",
            referral: "Captador é obrigatório.",
            notFoundData: "Nenhum dado encontrado."
          },
          access: {
            admin: "ADMINISTRADOR",
            user: "CORRETOR",
            finance: "FINANCEIRO",
            mkt: "MARKETING",
            construct: "CONSTRUTORA"
          }
        },
        helpDesk: {
          title: "Central de Ajuda",
          subTitle:
            "Abra um chamado e receba suporte especializado para encontrar soluções rápidas.",
          labels: {
            priorityLow: "Baixa",
            priorityNormal: "Média",
            priorityHigh: "Alta",
            statusOpen: "Aberto",
            statusPending: "Aguardando",
            statusClosed: "Fechado",
            btnAdd: "Abrir Chamado",
            it: "Suporte Técnico",
            commercial: "Comercial",
            questions: "Duvidas",
            others: "Outros Assuntos",
            access: "Acessar",
            departments: "Departamentos",
            priority: "Prioridade",
            required: {
              subject: "Assunto do chamado é obrigatório.",
              department: "Selecione um departamento.",
              message: "Mensagem é obrigatória.",
              note: {
                id: "ID do ticket é obrigatório.",
                content: "Digite uma mensagem.",
                file: "Arquivo é obrigatório."
              }
            },
            error: {
              createTicket: "Ops! Erro ao abrir um novo chamado.",
              deleteTicket: "Ops! Erro ao deletar chamado.",
              updateTicket: "Ops! Erro ao atualizar chamado.",
              createNote: "Ops! Erro ao enviar mensagem.",
              uploadNote: "Ops! Erro ao enviar arquivo."
            },
            success: {
              createTicket: "Chamado aberto com sucesso.",
              deleteTicket: "Chamado deletado com sucesso.",
              updateTicket: "Chamado atualizado com sucesso.",
              createNote: "Mensagem enviada com sucesso.",
              uploadNote: "Arquivo enviado com sucesso."
            }
          },
          modalAdd: {
            title: "Abrir novo chamado",
            subject: "Assunto",
            department: "Departamento",
            priority: "Prioridade",
            status: "Status",
            btnAdd: "Abrir chamado",
            createdAt: "Data da Abertura",
            actions: "Ações",
            update: "Atualizar chamado",
            btnSave: "Salvar",
            btnDel: "Deletar"
          }
        },
        internalHelpDesk: {
          title: "Chat",
          labels: {
            upload: "Subir Arquivo",
            send: "Enviar",
            message: "Digite sua mensagem",
            sending: "Enviando...",
            uploading: "Subindo...",
            download: "Baixar",
            detailsTicket: "Detalhes do Atendimento",
            subject: "Assunto",
            description: "Descrição",
            createdAt: "Data da Abertura",
            department: "Departamento",
            status: "Status",
            priority: "Prioridade"
          }
        },
        notFound: {
          title: "404 - Pagina não encontrada",
          subtitle: `Ops! Parece que você se perdeu no caminho... Mas não se preocupe,
          estamos aqui para ajudar você.`,
          btnHome: "Pagina Inicial"
        },
        dashboard: {
          alertToast:
            "Atenção: sua fatura está prestes a vencer. Regularize seu pagamento!",
          title: "Painel de Controle",
          totalContacts: "Total de contatos",
          totalUsers: "Total de usuários",
          totalProperties: "Total de propriedades",
          last12Months: "Contatos dos últimos 12 meses",
          addContacts: "Adicionar Contatos",
          notNotifications: "Nenhuma notificação para exibir",
          cancel: "Cancelar",
          more: "Saiba Mais",
          dialogPopup: {
            title: "Area Restrita",
            description:
              "Para acessar esta área, você precisa fazer upgrade do seu plano atual. Desbloqueie recursos premium e aproveite todos os benefícios.",
            back: "Voltar",
            upgrade: "Fazer Upgrade Agora"
          },
          labels: {
            titleGraphicLine: "Atendimentos Últimos 12 Meses",
            value: "Atendimentos",
            total: "Total de conversas",
            cpfOrCnpj: "CPF ou CNPJ inválido.",
            concludedNegotiations: "Negociações Concluídas",
            cardOne: "Total de Conversas",
            cardTwo: "Protocolos Ativos",
            cardThree: "Conversas Hoje",
            cardFour: "Atendimentos Finalizados",
            titleSale: "Vendas Últimos 12 Meses",
            titleContacts: "Contatos Últimos 12 Meses",
            totalContacts: "Total de Contatos",
            totalValue: "Valor de Venda",
            totalCommission: "Total da Comissão",
            funnelNegotiation: "Funil de Negociações",
            calendarTitle: "Calendário",
            btnClear: "Limpar",
            type: "Tipo",
            subtype: "SubTipo",
            dateStart: "Data Inicial",
            dateEnd: "Data Final",
            filters: "Filtros",
            interval: "Até",
            search: "Pesquisar",
            period: "Selecione o Período"
          }
        },
        config: {
          title: "Configurações",
          successEdit: "Configurações salvas com sucesso.",
          upload: "Upload Foto",
          uploadFavicon: "Upload Favicon",
          uploadLogo: "Upload Logotipo",
          uploadBackground: "Upload Imagem de Fundo",
          errorEdit: "Erro ao salvar as configurações.",
          socialMedia: {
            title: "Redes Sociais",
            btn: "Editar"
          },
          address: {
            title: "Endereço",
            state: "Estado",
            city: "Cidade",
            neighborhood: "Bairro",
            street: "Rua",
            number: "Número"
          },
          contact: {
            title: "Contato",
            phone: "Telefone"
          },
          about: {
            title: "Sobre",
            desc: "Descreva você ou sua empresa:",
            img: "Imagem de destaque",
            video: "Vídeo"
          },
          whatsapp: {
            title: "Whatsapp",
            message: "Mensagem do Whatsapp",
            status: "Ativar Whatsapp"
          },
          view: {
            title: "Visual",
            titleSite: "Título",
            cnpj: "CNPJ",
            creci: "CRECI"
          },
          scripts: {
            title: "Scripts"
          }
        },
        checkout: {
          title: "Pagamento",
          titleError: "Erro Pagamento",
          titleSuccess: "Sucesso Pagamento",
          errorCredit: "Erro ao processar pagamento por cartão.",
          successCredit: "Pagamento realizado com sucesso.",
          errorCpf: "O CPF ou CNPJ do seu perfil é inválido. Clique aqui",
          steps: {
            user: "Usuário",
            payment: "Pagamento"
          },
          oneStep: {
            title: "Dados Pessoais",
            name: "Nome",
            postalCode: "CEP",
            phone: "Telefone",
            addressNumber: "Número de Endereço"
          },
          twoStep: {
            credit: "Cartão de Crédito",
            pix: "PIX",
            methodTitle: "Método de Pagamento",
            selectMethod: "Selecione o método de pagamento",
            holderName: "Nome Impresso no Cartão",
            number: "Número do Cartão",
            expiryMonth: "Mês de Expiração",
            expiryYear: "Ano de Expiração",
            ccv: "CCV",
            titleQr: "QR Code para pagamento PIX",
            loadQr: "Gerando PIX...",
            installments: "Parcelas",
            expire: "Expira em",
            product: "Produto",
            mode: "Tipo",
            value: "Valor",
            pixSuccess: "Pix confirmado com sucesso."
          },
          info: {
            title: "Informações do Titular do Cartão"
          },
          navigation: {
            back: "Voltar",
            next: "Próximo",
            finish: "Finalizar",
            finishing: "Finalizando..."
          },
          labels: {
            name: "O nome é obrigatório.",
            email: "O e-mail deve ser válido.",
            cpfCnpj: "O CPF/CNPJ é obrigatório.",
            postalCode: "O código postal é obrigatório.",
            phone: "O telefone é obrigatório.",
            addressNumber: "O número do endereço é obrigatório.",
            creditCardHolderInfo: {
              name: "O nome do titular é obrigatório.",
              email: "O e-mail do titular deve ser válido.",
              cpfCnpj: "O CPF/CNPJ do titular é obrigatório.",
              postalCode: "O código postal do titular é obrigatório.",
              phone: "O telefone do titular é obrigatório.",
              addressNumber: "O número do endereço do titular é obrigatório."
            },
            creditCard: {
              holderName: "O nome do titular do cartão é obrigatório.",
              number:
                "Número do Cartão inválido! Deve ter pelo menos 16 caracteres.",
              expiryMonth:
                "Mês de expiração inválido! Deve ter pelo menos 2 caracteres.",
              expiryYear:
                "Ano de expiração inválido! Deve ter pelo menos 4 caracteres.",
              ccv: "CCV inválido! Deve ter pelo menos 3 caracteres.",
              installments: "O número de parcelas é obrigatório."
            },
            error: {
              title: "Houve um problema ao processar seu pagamento.",
              description:
                "Por favor, tente novamente ou selecione outro método de pagamento. Se o erro persistir, entre em contato com nosso suporte para que possamos ajudá-lo.",
              retry: "Tentar novamente"
            },
            success: {
              title: "Pagamento realizado com sucesso.",
              description:
                "Seu pagamento foi confirmado com sucesso! Agora você pode aproveitar o que adquiriu. Confira abaixo o comprovante de pagamento.",
              proof: "Visualizar comprovante",
              link: "Voltar ao sistema"
            }
          }
        },
        myAccount: {
          title: "Minha Conta",
          changePass: "Alterar Senha",
          firstname: "Primeiro Nome",
          lastname: "Sobrenome",
          phone: "Telefone",
          changeCover: "Alterar Capa",
          license: "Licença",
          update: "Atualizar",
          modalTitle: "Alterar sua senha",
          planActive: "Plano",
          updatePlan: "Alterar Plano",
          maxProperties: "Limite de Imóveis",
          maxPhotos: "Limite de Fotos",
          value: "Valor",
          periodPlan: "Período de assinatura",
          until: "Até",
          freePlan: "Gratuito",
          cancelPlan: "Cancelar Plano",
          confirmCancel:
            "Tem certeza de que deseja cancelar seu plano? Após o término do período de assinatura, sua conta será transformada para o plano Free.",
          lifetime: "Vitalicio",
          modalBtn: "Salvar",
          password: "Senha",
          password2: "Repita a senha",
          passError: "Senha com menos de 6 caracteres ou senhas não coincidem",
          passSuccess: "Senha alterada com sucesso",
          changeSuccess: "Atualizado com sucesso",
          changeError: "Falha, tente novamente!",
          document: "Documento",
          city: "Cidade",
          state: "Estado",
          userData: "Dados Pessoais",
          markWater: "Marca d'água",
          username: "Nome de usuário",
          unlimited: "Ilimitado",
          description: "Descrição",
          error: {
            username: "Ops! Erro ao alterar nome de usuário.",
            cancel: "Ops! Erro ao cancelar plano."
          },
          success: {
            username: "Nome de usuário alterado com sucesso.",
            cancel: "Plano cancelado com sucesso."
          },
          labels: {
            errorUpdate: "Ops! Erro ao atualizar imagem.",
            successUpdate: "Imagem alterada com sucesso.",
            errorSelected: "Nenhuma imagem selecionada."
          }
        },
        newPassWd: {
          title: "Recuperar Senha",
          button: "Redefinir Senha",
          password: "Senha",
          password2: "Repita a senha"
        }
      },
      system: "Sistema",
      logout: "Sair",
      myAccount: "Minha Conta",
      en: "Inglês",
      pt: "Português",
      planExpired:
        "Seu plano está vencido. Renove agora para continuar utilizando nossos serviços.",
      lang: "Idioma do site",
      notifications: "Notificações",
      settings: "Configurações",
      help: "Ajuda",
      profile: "Perfil",
      darkMode: "Modo Escuro",
      lightMode: "Modo Claro",
      payments: "Pagamentos",
      marketplace: "Mercado",
      logoutSystem: "Sair do Sistema",
      popupInfo: {
        invoiceExpiredTitle: "Seu plano está vencido",
        invoiceExpiredSubtitle:
          "Renove agora para continuar utilizando nossos serviços."
      },
      groups: {
        shortcuts: "Atalhos",
        finance: "Financeiro",
        whatsappReview: "Validacao WhatsApp",
        settings: "Configurações"
      },
      statesBusiness: {
        active: "LEADS (Potenciais Clientes)",
        approved: "ATIVO/APROVADO",
        contract: "CONTRATO ASSINADO",
        closing: "PROCESSO DE ENCERRAMENTO"
      },
      alerts: {
        successCreate: "Criado com sucesso",
        successEdit: "Editado com sucesso",
        successDelete: "Deletado com sucesso",
        errorCreate: "Falha ao criar",
        errorEdit: "Falha na edição",
        errorDelete: "Falha ao deletar",
        suportError: "Falha no envio, fale com o suporte"
      }
    }
  }
}

export { messages }
